import React, { PropsWithChildren } from "react"
import { CSSTransition } from 'react-transition-group'
import { PropsWithTheme } from "../../library/Theme"

interface SecondaryIconButtonProps {
  id?: string
  text: string
  onPress?: () => void
}

export default function SecondaryIconButton({ theme, id, text, children, onPress }: PropsWithChildren<PropsWithTheme<SecondaryIconButtonProps>>) {
  return (
    <CSSTransition in appear timeout={300} classNames="iconAnimate" unmountOnExit>
      <div id={id} className="secondaryIconButton" onClick={onPress}>
        {children}
        <br />
        <span className="text" style={theme.textStyle}>{text}</span>
      </div>
    </CSSTransition>
  )
}
